import LoadingRegion from './LoadingRegion';
import RiskCardSkeleton from './RiskCardSkeleton';
import RiskTableSkeleton from './RiskTableSkeleton';

export default function DashboardRisksSkeleton({ count = 6, viewMode = 'table' }) {
  const safeCount = Math.min(Math.max(count, 1), 12);

  if (viewMode === 'table') {
    return <RiskTableSkeleton count={safeCount} />;
  }

  return (
    <LoadingRegion label="Загрузка списка рисков">
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: safeCount }, (_, index) => (
          <RiskCardSkeleton key={index} />
        ))}
      </div>
    </LoadingRegion>
  );
}
